  <template>
    <div class="d-flex align-items-center justify-content-center ag-overall">
        <div class="w-50">
            <ag-loading v-if="loading" />
            <div v-if="!loading" class="text-center mt-5">
                <div>
                    <h4 class="title mb-1">{{ $t("group") }}</h4>
                    <p>{{ this.groupName }}</p>
                </div>
                <div>
                    <h4 class="title mb-1">{{ $t("policyName") }}</h4>
                  <p>
                    {{ policy.folderName && policy.folderName !== "" 
                        ? policy.folderName 
                        : policy.policyName || $t("N/A") }}
                  </p>

                </div>
            </div>
            <div class="d-flex justify-content-center mt-4">
                <button class="btn" v-if="hasRuleId" @click="goToRuleDetail">
                    Go to Rule Detail
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from "@/store";
import AgLoading from "@/components/ag-loading/index.vue";
import api from "@/api/index";
import { notify } from "@kyvg/vue3-notification";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { AuthActionTypes } from "@/store/modules/auth/action-types";
import { Roles } from "@/helpers/enums/Roles";
const store = useStore();

export default {
    name: "ag-event-policy",
    components: { AgLoading, },
    props: {
        data: {
            type: Array,
            default: null,
        },
        options: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            groupName: null,
            policy: null,
            loading: false,
            siteInfo: null,
        }
    },
    async created() {
        this.loading = true;
        try {
            const res = await api.groups.getById(this.selectedRow.groupGuid);
            const siteApi =await api.sites.getById(res.data.entityData.siteGuid)
            this.siteInfo= siteApi.data.entityData;
           
            if (res.data.entityData && res.data.statusCode === 200) {
                this.groupName = res.data.entityData.name;
                this.policy = await store.dispatch(GeneralActionTypes.GET_EVENT_POLICY_NAME, {
                    mainId: res.data.entityData.mainId,
                    ruleId: this.selectedRow.ruleId ?? this.selectedRow.EventDetails?.Rule?.RuleId,
                    ruleSource: this.selectedRow.ruleSource ?? this.selectedRow.EventDetails?.Rule?.RuleSource,
                    ruleName: this.selectedRow.ruleName ?? this.selectedRow.EventDetails?.Rule?.RuleName,
                    targetPath: this.selectedRow.target
                });
                this.loading = false
            } else {
                notify({
                    title: this.$t('errorOccurred'),
                    text: res.data.message,
                    type: "error",
                    duration: 8000,
                });
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            this.loading = false;
        }
    },
    computed: {
        selectedRow() {
            return store.state.general.selectedExpandedRow;
        },
        hasRuleId() {
            try {
                return this.policy && this.policy.items && this.policy.items[0] && this.policy.items[0].ruleId != null;
            } catch (e) {
                return false;
            }
        }
    },
    watch: {
        selectedRow(newItem, oldItem) {
            setTimeout(() => {
                this.getList();
            }, 100);
        },
    },
    methods: {
        changeRole(role) {
            let tempUser = store.getters.mainUser;
            const roleIndex = tempUser.findIndex((i) => i.type === "role");
            localStorage.setItem("scopeChange", true);
            localStorage.setItem("selectedRole", role);
            localStorage.setItem('changingScope', true);
            if (roleIndex > -1) {
                tempUser[roleIndex].value = role;
                store.dispatch(AuthActionTypes.SET_USER, tempUser);

                return true;
            }
            return false;
        },
        goToRuleDetail() {
            const matchType = this.policy.items[0].matchType || '';
            const policyId = this.policy.items[0].policyId || this.policy.items[0].id;

            if (this.changeRole(Roles.GroupAdmin)) {
                const existingGroup = localStorage.getItem('group');
                if (!existingGroup || existingGroup === '{}') {
                    const groupObj = {
                        key: this.selectedRow.groupGuid,
                        mainid: (this.policy.items[0].groupId || null),
                        value: this.groupName || null,
                        siteId: this.siteInfo.siteGuid
                    };

                    const agmsGroupObj = {
                        mainid: this.policy.items[0].groupId || null,
                        group: this.groupName || null,
                        siteId: this.siteInfo.siteGuid
                    };

                    if (groupObj.key && groupObj.mainid) {
                        localStorage.setItem("selectedScopeId", this.selectedRow.groupGuid);
                        localStorage.setItem("site", JSON.stringify({
                            key: this.siteInfo.siteGuid,
                            value: this.siteInfo.name
                        }));
                        localStorage.setItem('group', JSON.stringify(groupObj));
                        localStorage.setItem('agms_group', JSON.stringify(agmsGroupObj));
                        //group scope transition

                        localStorage.setItem("selectedRole", Roles.GroupAdmin);
                        localStorage.setItem("agms_template", JSON.stringify({}));
                        store.dispatch(AuthActionTypes.SET_SITE, { key: this.siteInfo.siteGuid, mainid: this.siteInfo.mainId, value: this.siteInfo.name });
                        store.dispatch(AuthActionTypes.SET_GROUP, {
                            key: this.selectedRow.groupGuid,
                            value: this.groupName,
                            mainid: this.policy.items[0].groupId || null,
                            siteId: this.siteInfo.siteGuid
                        });

                        store.dispatch(AuthActionTypes.SET_AGMS_TEMPLATE, {});
                        store.dispatch(
                            GeneralActionTypes.SET_COMPKEY,
                            store.getters.compKey + 1
                        );
                        store.dispatch(GeneralActionTypes.SET_AGMS_BREADCRUMB_DATA, {
                            group: { group: this.groupName, mainid: this.policy.items[0].groupId },
                            site: {
                                site: this.siteInfo.name,
                                siteGuid: this.siteInfo.siteGuid,
                            },
                        });
                        store.dispatch(GeneralActionTypes.SET_AGMS_BREADCRUMB_STATUS, true);
                    }

                }
            }

            // AppGroup 
            if (matchType === 'AppGroup' || matchType === 'AppGroupProcess') {
                const ruleId = this.policy.items[0].ruleId;
                this.$router.push({ name: 'appGroupDetail', query: { id: policyId, tab: 'process', ruleId } });
                return;
            }
            if (matchType === 'AppGroupRegistry') {
                const ruleId = this.policy.items[0].ruleId;
                this.$router.push({ name: 'appGroupDetail', query: { id: policyId, tab: 'registry', ruleId } });
                return;
            }
            if (matchType === 'AppGroupFileAccess') {
                const ruleId = this.policy.items[0].ruleId;
                this.$router.push({ name: 'appGroupDetail', query: { id: policyId, tab: 'fileAccess', ruleId } });
                return;
            }
            if (matchType === 'AppGroupCodeLoad') {
                const ruleId = this.policy.items[0].ruleId;
                this.$router.push({ name: 'appGroupDetail', query: { id: policyId, tab: 'codeLoad', ruleId } });
                return;
            }
            // Global Policy
            if (matchType === 'GlobalPolicy-Registry') {
                const ruleId = this.policy.items[0].ruleId;
                this.$router.push({ name: 'globalPolicyManagement', query: { tab: 'registry', ruleId } });
                return;
            }
            if (matchType === 'GlobalPolicy-File') {
                const ruleId = this.policy.items[0].ruleId;
                
                this.$router.push({ name: 'globalPolicyManagement', query: { tab: 'fileAccess', ruleId } });
                return;
            }
            if (matchType === 'GlobalPolicy-CodeLoad') {
                const ruleId = this.policy.items[0].ruleId;
                this.$router.push({ name: 'globalPolicyManagement', query: { tab: 'codeLoad', ruleId } });
                return;
            }
            // File Extensions policy
            if (matchType === 'FileExtension') {
                this.$router.push({ name: 'fileTypesPolicy' });
                return;
            }
        }
    }
};
</script>

<style>
.ag-overall {
    padding: 20px 0px;

    button {
        box-shadow: 0px 3px 6px #00000059 !important;
        color: #1878af;
        margin-left: 1rem;
        margin-right: 1rem;
        padding: 0.7rem;
        font-size: 17px;
    }
    
    button:hover {
        background: #8e8e8e;
        color: white;
    }
    h2 {
        color: #5e5e5e;
    }

    h4 {
        font-weight: 300;
    }

    .title {
        color: #5e5e5e;
        font-weight: 700;
    }
}
</style>